import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Grid,
  Switch,
} from "@mui/material";
import { CustomStack } from "../../../common/components";

// BreakdownWindow is a functional component for rendering a configuration panel
// that allows the user to toggle between detailed and simple breakdowns
// and to select a specific breakdown option from a list.
//
// Props:
// - isDetailed: Boolean indicating whether the detailed breakdown is enabled.
// - chartBreakdown: The currently selected breakdown option.
// - chartBreakdownList: List of available breakdown options.
// - handleIsDetailedChange: Handler for toggling the "Details" switch.
// - handleBreakdownChange: Handler for selecting a breakdown option.


const BreakdownWindow = ({
  isDetailed,
  chartBreakdown,
  chartBreakdownList,
  handleIsDetailedChange,
  handleBreakdownChange,
}) => (
  <CustomStack>
    <FormControl>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <FormLabel>Breakdown</FormLabel>
        <FormControl>
          <FormControlLabel
            control={<Switch checked={isDetailed} onChange={handleIsDetailedChange} />}
            sx={{ "& .css-1cn7wjw-MuiTypography-root": { fontSize: 12 } }}
            label="Details"
          />
        </FormControl>
      </Grid>
      <RadioGroup value={chartBreakdown} onChange={handleBreakdownChange}>
        {chartBreakdownList?.map((item) => {
          const value = isDetailed ? item.detailedValue : item.simpleValue;
          return (
            <FormControlLabel
              key={item.id}
              value={value}
              control={<Radio />}
              label={item.label}
              sx={{ my: -1 }}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  </CustomStack>
);
//
export default BreakdownWindow;
